class SearchDropdown extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['trigger', 'dropdown', 'input']
  }

  setupListeners () {
    super.setupListeners()

    this.onTriggerClick = this.onTriggerClick.bind(this)
    this.onBodyClick = this.onBodyClick.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.onTriggerClick)
    this.listeners.add(document.body, 'click', this.onBodyClick)

    if (this.els?.cancel?.element) {
      this.onCancelClick = this.onCancelClick.bind(this)

      this.listeners.add(this.els.cancel.element, 'click', this.onCancelClick)
    }
  }

  onTriggerClick () {
    this.isActive = !this.isActive
  }

  onCancelClick () {
    this.isActive = false
    this.els.input.element.value = ''
  }

  onBodyClick (event) {
    if (event.target.closest(this.localName)) return
    if (!this.isActive) return

    this.isActive = false
  }

  get isActive () {
    return this.hasAttribute('active')
  }

  set isActive (val) {
    val ? this.setAttribute('active', '') : this.removeAttribute('active')

    val
      ? document.body.classList.add('util-SiteOverflowed', 'util-KlevuActive')
      : document.body.classList.remove(
        'util-SiteOverflowed',
        'util-KlevuActive',
      )

    window.setTimeout(() => this.els.input.element.focus(), 150)
  }
}

if (!customElements.get('search-dropdown')) {
  customElements.define('search-dropdown', SearchDropdown)
}
